module.exports = __webpack_public_path__ + "static/media/ic_send-email.d47afd08.svg";